import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query GetUsers(
    $first: Int!,
    $page: Int!,
    $whereConditions: QueryUsersWhereWhereConditions
    $orderBy: [QueryUsersOrderByOrderByClause!]
  ) {
      users(
        first: $first,
        page: $page,
        where: $whereConditions,
        orderBy: $orderBy
      ) {
        data {
          id,
          first_name,
          last_name,
          full_name,
          title,
          email,
          role,
          email_verified_at,
          countries {
            id,
            code
          },
          company {
              id,
              name,
              slug,
              logo {
                url,
                width,
                height
              }
          }
        }
        paginatorInfo {
          currentPage
          lastPage
          hasMorePages
          count
          firstItem
          lastItem
          perPage
          total
        }
      }
  }
`

export const GET_DISTRIBUTORS = gql`
  query GetDistributors(
    $first: Int!,
    $page: Int!
  ) {
      distributors(
        first: $first,
        page: $page
      ) {
        data {
          id,
          first_name,
          last_name,
          full_name,
          title,
          email,
          countries {
            id,
            code
          },
          company {
              id,
              name,
              slug,
              logo {
                url,
                width,
                height
              }
          }
        }
        paginatorInfo {
          currentPage
          lastPage
          hasMorePages
          count
          firstItem
          lastItem
          perPage
          total
        }
      }
  }
`
